import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { accountSlice } from '@/modules/auth/store/slice';
import { diagnosisSlice } from '@/modules/forms/store/slice';
import homeSlice from '@/modules/home/store/slice';

const persistConfig = {
  key: 'root',
  storage,
  // Specify which reducers to persist
  whitelist: ['account', 'diagnosis'],
};

const rootReducer = combineReducers({
  [accountSlice.name]: accountSlice.reducer,
  [diagnosisSlice.name]: diagnosisSlice.reducer,
  [homeSlice.name]: homeSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;